export default {
    REACT_APP_EMAILJS_RECEIVER: "sashi@fankave.com",
    REACT_APP_EMAILJS_SERVICEID: "gmail",
    REACT_APP_EMAILJS_TEMPLATEID: "template_13k3knm",
    REACT_APP_EMAILJS_USERID: "user_RHlD4u8mJ477FjuCllEws",
    REACT_APP_EMAILJS_WEBSITE: "fankave.com"
  };